import {
  windZoneToPressureProposal,
  windZoneToSpeedProposal,
} from '../components/WindloadsTab/components/BaseParameterFields/constants'
import { lookupSimplifiedGustPressureQp } from '../components/WindloadsTab/components/BaseParameterFields/simplifiedMethodQpLookup'
import { DEFAULT_BUILDING_DIMENSIONS } from '../components/WindloadsTab/components/BaseParameterFields/utils'

export const windLoadComputationMethodOptions: {
  value: WindLoadComputationMethod
  label: string
}[] = [
  {
    value: 'SimplifiedMethod',
    label: 'Vereinfachtes Verfahren bis 25 m Höhe (DIN EN 1991-1-4/NA)',
  },
  {
    value: 'GroundRoughnessConsidered',
    label: 'Genaueres Verfahren zur Erfassung der Bodenrauigkeit (DIN EN 1991-1-4/NA-B Tab. B.2)',
  },
]

export const defaultWindLoadParameters = (): WindLoadParameters => ({
  wind_zone: 1,
  wind_area_type: 'Inland',
  computationMethod: 'SimplifiedMethod',
  wind_speed: 22.5,
  baseWindPressure_q_b: 320,
  terrain_category: 'I',
  gustPressure_q_p: lookupSimplifiedGustPressureQp(1, 10) ?? 500,
  buildingHeightFor_q_p_lookup: 10,
  simplifiedMethodStandort: 'Binnenland',
})

export const isSimplifiedWindLoadMethod = (
  computationMethod?: WindLoadComputationMethod,
): boolean => computationMethod === 'SimplifiedMethod'

export const completeWindLoadParameters = (
  parameters: WindLoadParameters,
  wallHeight?: number,
): WindLoadParameters => {
  const defaults = defaultWindLoadParameters()
  const windZone = parameters.wind_zone ?? defaults.wind_zone
  const buildingHeightForQpLookup =
    parameters.buildingHeightFor_q_p_lookup && parameters.buildingHeightFor_q_p_lookup > 0
      ? parameters.buildingHeightFor_q_p_lookup
      : wallHeight ?? defaults.buildingHeightFor_q_p_lookup

  return {
    ...defaults,
    ...parameters,
    wind_speed:
      parameters.wind_speed && parameters.wind_speed > 0
        ? parameters.wind_speed
        : windZoneToSpeedProposal[windZone],
    baseWindPressure_q_b:
      parameters.baseWindPressure_q_b && parameters.baseWindPressure_q_b > 0
        ? parameters.baseWindPressure_q_b
        : windZoneToPressureProposal[windZone],
    terrain_category: parameters.terrain_category ?? defaults.terrain_category,
    gustPressure_q_p:
      parameters.gustPressure_q_p && parameters.gustPressure_q_p > 0
        ? parameters.gustPressure_q_p
        : lookupSimplifiedGustPressureQp(windZone, buildingHeightForQpLookup) ??
          defaults.gustPressure_q_p,
    buildingHeightFor_q_p_lookup: buildingHeightForQpLookup,
    simplifiedMethodStandort:
      parameters.simplifiedMethodStandort ?? defaults.simplifiedMethodStandort,
  }
}

export const windLoadSettingsToFormValues = (
  settings: WindLoadSettings,
  results: WindloadResults,
): WindLoadsFormValues => {
  const wallBuildingDimensions = settings.wallBuildingDimensions
  const computationMethod = settings.windLoadParameters.computationMethod ?? 'SimplifiedMethod'

  return {
    roofBuildingDimensions: settings.roofBuildingDimensions,
    qZoneBuildingDimensions:
      settings.qZoneBuildingDimensions ?? wallBuildingDimensions ?? DEFAULT_BUILDING_DIMENSIONS,
    wallBuildingDimensions,
    windBoxConfig: settings.windBoxConfig,
    baseParameters: {
      ...defaultWindLoadParameters(),
      ...settings.windLoadParameters,
      computationMethod,
    },
    roofAssignment: settings.roofAssignment,
    wallAssignment: settings.wallAssignment0,
    results,
  }
}

export const formValuesToWindLoadSettings = (data: WindLoadsFormValues): WindLoadSettings => {
  const isSimplified = isSimplifiedWindLoadMethod(data.baseParameters.computationMethod)

  return {
    roofBuildingDimensions: data.roofBuildingDimensions,
    qZoneBuildingDimensions: isSimplified ? null : data.qZoneBuildingDimensions,
    wallBuildingDimensions: data.wallBuildingDimensions,
    windBoxConfig: data.windBoxConfig,
    roofAssignment: data.roofAssignment,
    wallAssignment0: data.wallAssignment,
    windLoadParameters: completeWindLoadParameters(
      data.baseParameters,
      data.wallBuildingDimensions?.height,
    ),
  }
}
